<template>
  <div class="home">
    <p id="concreate-desk" class="has-text-weight-light has-text-left is-hidden-mobile">ConCreate</p>
    <p id="concreate-mobile" class="has-text-weight-light has-text-left is-hidden-tablet">ConCreate</p>
    <p class="subtitle has-text-left is-hidden-mobile">we are DTM circle</p>
<!--    TODO ロゴを画像にしてサイズを比で扱えるようにしてページスクロールが起きないようにする-->
    <div class="nav  is-hidden-desktop">
      <router-link to="/about">ABOUT</router-link>
      <router-link to="/works">WORKS</router-link>
      <router-link to="/member">MEMBER</router-link>
      <router-link to="/contact">CONTACT</router-link>
      <router-link to="/other">OTHER</router-link>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  components: {
  }
}
</script>


<style scoped>
  #concreate-desk{
    font-size:100px;
    padding--top: 20px;
    margin-left: 20px;
    margin-bottom: 0px;
    padding-bottom: 0px;
  }
  #concreate-mobile{

    -webkit-writing-mode: vertical-rl;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
    font-size:100px;
    margin-top: 20px;
    margin-right: 0px;
  }
  img{
    left: 20px;
    position: fixed;
    top: 10px;
  }
  .subtitle{
    color: gray;
    font-size: smaller;
    margin-left: 20px;
    margin-top: 0px;
  }

  .nav{
    flex-direction: column;
    margin-right: 30px;
    top: 0px;
    bottom: 0px;
  }
  .nav>a{
    display: flex;
    font-size: 25px;
    color:black;
    flex-direction: column;
    text-align: right;
  }
</style>